export interface TermsConditionsDialogOptions<T> {
  title: string;
  buttons: TermsConditionsDialogActionOptions<T>[];
  closeAction?: T;
  hasCloseButton?: boolean;
}

export interface TermsConditionsDialogActionOptions<T> {
  caption: string;
  action?: T;
}
